import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid'

interface Props {
  name: string
  companyNumber: string
  companyStatus: string
  dateOfCreation: string
  address: string
}

export const BusinessDetails = ({
  name,
  companyNumber,
  companyStatus,
  dateOfCreation,
  address,
}: Props) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col">
        <h2 className="text-2xl font-bold">{name}</h2>
        <p className="mt-1 flex items-center gap-1 text-blue-500 hover:underline">
          <a
            href={`https://find-and-update.company-information.service.gov.uk/company/${companyNumber}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {companyNumber}
          </a>
          <ArrowTopRightOnSquareIcon className="w-4 h-4" />
        </p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-600">
            Status
          </label>
          <p className="mt-1">{companyStatus}</p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-600">
            Incorporation Date
          </label>
          <p className="mt-1">
            {new Date(dateOfCreation).toLocaleDateString()}
          </p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-600">
            Address
          </label>
          <p className="mt-1">{address}</p>
        </div>
      </div>
    </div>
  )
}
